import setImageOptions from "app/media/helpers/setImageOptions";
import preloadImage from "components/ImageViewer/helpers/preload-image";
import { ImageLoadingState } from "components/ImageViewer/image-loading.enum";
import React, { useState, useEffect } from "react";
import { useInView } from "react-intersection-observer";
import { useWebPSupportCheck } from "react-use-webp-support-check";

export default function SimpleImage(props: any) {
    const { ref, inView, entry } = useInView({ triggerOnce: true, threshold: 0.2 });
    const [imageUrl, setImageUrl] = useState<string>();
    const supportsWebP = useWebPSupportCheck();
    const [imageLoadingState, setImageLoadingState] = useState<ImageLoadingState>(ImageLoadingState.NONE);
    useEffect(() => {
        if (entry && inView === true) {
            const boundingClientRect = entry.target.getBoundingClientRect();
            const boundingClientWidth = boundingClientRect?.width;
            const boundingClientHeight = boundingClientRect?.height;

            if (boundingClientWidth && boundingClientWidth > 0) {
                const clientWidth = boundingClientWidth * (window?.devicePixelRatio || 1);
                const clientHeight = boundingClientHeight * (window?.devicePixelRatio || 1);

                const heightRatio = clientHeight / clientWidth;
                const imageUrlWithResizeOptions = setImageOptions(
                    props?.src?.url,
                    clientWidth,
                    supportsWebP ? "webp" : props?.src?.extension,
                    props?.src?.crop,
                    props?.src?.focalPoint,
                    heightRatio
                );
                setImageUrl(imageUrlWithResizeOptions);

                preloadImage(imageUrlWithResizeOptions, setImageLoadingState);
            }
        }
    }, [entry?.target, inView]);

    return (
        <img
            ref={ref}
            className={props.className || "simple-image"}
            src={imageUrl}
            alt={props?.src?.alt || props?.src?.name || ""}
            loading="eager"
        />
    );
}
